module.exports = __webpack_public_path__ + "static/media/pricolImg.9871a315.svg";